import React from 'react'

import { Card } from '@material-ui/core'

const card = ({ children, customClass }) => {
  return <Card className={customClass}>{children}</Card>
}

export default card
